import { InputMask } from '@react-input/mask';
import { useContext, useEffect, useRef, useState } from 'react';
import CurrencyInput from 'react-currency-input-field';
import { BsHouses } from "react-icons/bs";
import { FaArrowRight, FaCheck, FaCreditCard, FaInfoCircle, FaMoneyBillWave, FaPhoneAlt, FaRegIdCard, FaRegUser, FaSearch, FaStreetView } from 'react-icons/fa';
import { FaPix } from 'react-icons/fa6';
import { HiOutlineDocumentText } from 'react-icons/hi2';
import { LuMapPin } from "react-icons/lu";
import ReactLoading from 'react-loading';
import BoxAlert from '../../components/boxAlert';
import ReturnButton from '../../components/returnButton';
import CompanyContext from '../../contexts/companyContext';
import '../../css/scrollbar.css';
import { useAppRouter } from '../../hooks/useAppRouter';
import useStorage from '../../hooks/useStorage';
import { formatValue } from '../../scripts/formatValue';
import { saveAddress } from '../../scripts/saveAddress';
import { searchAddressInfo } from '../../scripts/searchAddressInfo';
import { validateClientName } from '../../scripts/validateClientName';
import axios from '../../services/axios';
import SelectUserData from './components/selectUserData';
import styles from './css/registerDelivery.module.css';
import { getEstimatedOrderTime } from '../../scripts/getEstimatedOrderTime';
import {Timer} from 'lucide-react';
import DocumentValidator from '../../scripts/documentValidator';


const stripHtmlTags = (value) => (typeof value === 'string' ? value.replace(/<[^>]*>/g, '') : value);

const STEPS = ['Cliente', 'Endereço', 'Resumo'];

const PAYMENT_OPTIONS = [
    { value: '01', label: 'Dinheiro', Icon: FaMoneyBillWave },
    { value: '03', label: 'Cartão de crédito', Icon: FaCreditCard },
    { value: '04', label: 'Cartão de débito', Icon: FaCreditCard },
    { value: '17', label: 'PIX', Icon: FaPix },
];

function RegisterDeliveryData() {
    const storage = useStorage();
    const navigate = useAppRouter();
    const { companyData } = useContext(CompanyContext);
    const [phase, setPhase] = useState(1);
    const [name, setName] = useState(null);
    const [phone, setPhone] = useState(null);
    const [document, setDocument] = useState(null);
    const [postalCode, setPostalCode] = useState(null);
    const [street, setStreet] = useState(null);
    const [district, setDistrict] = useState(null);
    const [number, setNumber] = useState(null);
    const [previousUserData, setPreviousUserData] = useState([]);
    const cart = useRef(null);
    const [troco, setTroco] = useState(null);
    const [paymentMethod, setPaymentMethod] = useState(null);
    const [checkTroco, setCheckTroco] = useState(true);
    const [warnAlert, setWarnAlert] = useState({ show: false, title: null, text: null });
    const [sucessAlert, setSucessAlert] = useState({ show: false, data: null});
    const [selectAddressAlert, setSelectAddressAlert] = useState(false);
    const [loading, setLoading] = useState(false);
    const [searchButtonLoading, setSearchButtonLoading] = useState(false);
    const [estimatedOrderTime, setEstimatedOrderTime] = useState(null);




    // WHEN SCREEN IS LOAD
    useEffect(() => {
        // BUSCA OS DADOS DE CART
        let resCart = storage.get('CART');

        if (!resCart) {
            navigate('cart');
            return;
        }
        
        // CONSULTA OS DADOS DE PREÇO
        const subtotal = Number(resCart.cart_price ?? 0);
        const deliveryTax = Number(companyData.delivery_tax ?? 0);
        const total = subtotal + deliveryTax;

        resCart.summary = {
            subtotal,
            delivery_tax: deliveryTax,
            total,
        };

        cart.current = resCart;

        // BUSCA OS ENDEREÇOS JÁ CADASTRADOS PELO USUÁRIO
        const resUserData = storage.get('ADDRESS_LIST');
        
        const sanitizedAddressList = Array.isArray(resUserData)
            ? resUserData
                .map((item) => {
                    const address = item?.deliveryAddress ?? {};

                    return {
                        name: item?.name ?? null,
                        phone: item?.phone ?? null,
                        phoneHint: item?.phoneHint ?? (item?.phone ? `****${String(item.phone).slice(-4)}` : null),
                        document: item?.document ?? null,
                        deliveryAddress: {
                            postalCode: address?.postalCode ?? null,
                            street: address?.street ?? null,
                            number: address?.number ?? null,
                            district: address?.district ?? null,
                            formattedAddress: address?.formattedAddress ?? null,
                        },
                        createdAt: item?.createdAt ?? Date.now(),
                    };
                })
                .filter((item) => item?.deliveryAddress?.postalCode && item?.deliveryAddress?.number)
            : [];

        // if (JSON.stringify(sanitizedAddressList) !== JSON.stringify(resUserData ?? [])) {
        //     storage.saveWithTTL('ADDRESS_LIST', sanitizedAddressList, 43200);
        // }

        setPreviousUserData(sanitizedAddressList.length > 0 ? sanitizedAddressList : []);
        
        if(sanitizedAddressList.length > 0 && phase == 1){
            setSelectAddressAlert(true);
        }

        handleGetEstimatedOrderTime();
    }, []);


    const handleGetEstimatedOrderTime = async () => {
        const resEstimatedTime = await getEstimatedOrderTime(companyData.id);

        if(!resEstimatedTime){
            return;
        }

        setEstimatedOrderTime(resEstimatedTime);
    }


    // FUNÇÃO DE CONTROLE DE RETURN DO BOTÃO DO HEADER
    const handleReturnScreen = () => {
        if(phase > 1) {
            setPhase(phase - 1);

        } else {
            navigate('cart');
        }
    }



    // CREATE ORDER FUNCTION =============================>
    const makeOrder = async () => {
        try {
            setLoading(true);
            
            const deliveryAddress = {
                postalCode: postalCode,
                street: street,
                number: number,
                district: district,
                formattedAddress: `${street}, ${number} - ${district}`,
            };

            if(!paymentMethod){
                setWarnAlert({show: true, title: 'Alerta', text: 'Selecione um método de pagamento para continuar!'});
                return;
            }

            const trocoFormatted = troco ? parseFloat(troco.replace('R$', '').replaceAll('.','').replace(/\s/g, '').replace(',', '.')) : null;

            // Monta o objeto do pagamento do pedido
            const label = 
                paymentMethod == '01' ? 'Dinheiro' 
                : paymentMethod == '03' ? 'Cartão de crédito' 
                : paymentMethod == '04' ? 'Cartão de débito' 
                : 'Pagamento instantâneo (PIX)';

            const payment = {
                methods: [{
                    label: label,
                    value: cart.current.summary.total,
                    method: paymentMethod,
                    change_for: paymentMethod == '01' ? trocoFormatted : null,
                }],
                totalPrice: cart.current.summary.total,
                subtotal: cart.current.summary.subtotal,
                delivery_tax: cart.current.summary.delivery_tax,
                total: cart.current.summary.total,
            }

            if (cart.current.products.length == 0) {
                setWarnAlert({ show: true, title: 'Alerta', text: 'Nenhum produto no pedido para ser finalizado. Selecione os produtos e depois retorne aqui para completar-mos seu pedido!' });
                return;
            }
                
            // SALVA OS DADOS DE PEDIDO NA TABELA "orders"
            const existingDeliverySession = storage.get('DELIVERY_ACCOUNT_SESSION');
            const currentSessionUUID = existingDeliverySession?.sessionUUID ?? null;

            const res = await axios.post(`/smartmenu/order/register/delivery`, {
                companyId: companyData.id,
                customer: {
                    name: name,
                    phone: phone,
                    document: document ?? null,
                },
                deliveryAddress: deliveryAddress,
                subtotal: cart.current.summary.subtotal,
                total: cart.current.summary.total,
                openCart: cart.current.datetime,
                products: cart.current.products,
                payments: payment,
                type: 'delivery',
                estimatedOrderTime: estimatedOrderTime,
                sessionUUID: currentSessionUUID,
            }, {
                headers: {
                    ...(currentSessionUUID ? { 'x-session-uuid': currentSessionUUID } : {}),
                },
            });

            if (res.status == 200) {
                storage.exclude('CART');

                const sessionUUID = res.data?.sessionUUID ?? currentSessionUUID;

                if (sessionUUID) {
                    storage.saveWithTTL('DELIVERY_ACCOUNT_SESSION', {
                        created_at: Date.now(),
                        company_id: companyData.id,
                        sessionUUID,
                    }, 14400);
                }
                
                // SALVA OS DADOS DE ENDEREÇO DO CLIENTE
                saveAddress({
                    name: name,
                    phone: phone,
                    document: document ?? null,
                    deliveryAddress: deliveryAddress
                }, storage);

                navigate('account');
            }

        } catch (error) {
            console.error('ERROR - SAVE ORDER IN DB: ', error);
            setWarnAlert({ show: true, title: 'ERRO', text: error?.response?.data?.error });
            
        } finally {
            setLoading(false);
        }
    };


    const handleProceedPhase = () => {
        try{
            switch(phase) {
                case 1:
                    // VALIDA NOME COMPLETO DO CLIENTE
                    const resValidateName = validateClientName(name);

                    if (!resValidateName){
                        setWarnAlert({show: true, title: 'Alerta', text: 'Insira um nome válido para continuar (nome e sobrenome, sem abreviaturas).'});
                        return;
                    }

                    // PHONE (BUT ONLY NUMBERS)
                    let formatPhone;

                    if (phone) {
                        formatPhone = phone.replace(/\(/g, '').replace(/\)/g, '').replace(' ', '').replace(/\-/g, '');
                    }

                    const validatePhone = formatPhone && formatPhone.length === 11 ? true : false;

                    if (!validatePhone) {
                        setWarnAlert({show: true, title: 'Alerta', text: 'Insira um telefone válido para continuar com o registro.'});
                        return;
                    }
                    
                    if (!document) {
                        setWarnAlert({ show: true, title: 'Alerta', text: 'Insira o seu CPF para continuar.' });
                        return;
                    }

                    const validDocument = DocumentValidator(document);

                    if (!validDocument) {
                        setWarnAlert({ show: true, title: 'Alerta', text: 'Insira um número de CPF válido para continuar.' });
                        return;
                    }

                    setPhase(2);
                    break;

                case 2:
                    if(!street || !number || !district) {
                        setWarnAlert({ show: true, title: 'Alerta', text: 'Por favor, insira um endereço completo e correto para continuar!' });
                        
                    } else {
                        setPhase(3);
                    }

                    break;

                default: break;
            }
        } catch (error) {
            console.error('ERROR - PROCEED PHASE FUNCTION:', error);
        }
    }



    const handleSearchAddress = async () => {
        try{
            setSearchButtonLoading(true);
            const res = await searchAddressInfo({postalCode: postalCode});

            setStreet(res.logradouro);
            setDistrict(res.bairro);
        
        } catch (error) {
            console.error('ERROR - SEARCH ADDRESS INFO:', error);
            setWarnAlert({ show: true, title: 'ERRO', text: error.message });
        
        } finally {
            setSearchButtonLoading(false);
        }
    } 


    const handleRemoveUserData = (data) => {
        const updatedList = previousUserData.filter((item) => item.createdAt !== data.createdAt);

        setPreviousUserData(updatedList);
        storage.save('ADDRESS_LIST', updatedList);
    }


    const handleSelectUserData = (data) => {
        setName(data.name ?? null);
        setPhone(data.phone ?? null);
        setDocument((prev) => data.document ?? prev ?? null);

        const add = data.deliveryAddress;
        setPostalCode(add.postalCode ?? null);
        setStreet(add.street ?? null);
        setDistrict(add.district ?? null)
        setNumber(add.number ?? null);
        
        return;
    }





    // SCREEN =======================================================================>
    return (
        <div style={{ flex: 1 }}>

            <div className={styles.screen} style={{'--brand': companyData.background_color, '--on-brand': companyData.text_color}}>
                <div className={styles.headerRegister} style={{backgroundColor: companyData.background_color}}>
                    <ReturnButton showText={true} action={() => handleReturnScreen()}/>
                    <p className={styles.titleHeader} style={{color: companyData.text_color}}>Dados do pedido</p>
                </div>

                {/* INDICADOR DE ETAPAS */}
                <div className={styles.stepper}>
                    {STEPS.map((label, index) => {
                        const stepNumber = index + 1;
                        const stepClass = [
                            styles.step,
                            phase >= stepNumber ? styles.reached : '',
                            phase == stepNumber ? styles.current : '',
                        ].join(' ');

                        return (
                            <div key={label} className={stepClass}>
                                <div className={styles.stepCircle}>
                                    {phase > stepNumber ? <FaCheck size={14} /> : stepNumber}
                                </div>
                                <span className={styles.stepLabel}>{label}</span>
                            </div>
                        );
                    })}
                </div>


                <div className={styles.container} key={phase}>

                    {phase == 1 ? (
                        <>
                            <h1 className={styles.titleForm}>Dados pessoais</h1>

                            <span className={styles.subtitleText}>
                                Insira seus dados de contato para prosseguir com seu pedido!
                            </span>

                            <div className={styles.formInputs}>
                                <div className={styles.field}>
                                    <label className={styles.label} htmlFor="clientName">Nome completo</label>
                                    <div className={styles.inputArea}>
                                        <div className={styles.iconArea}>
                                            <FaRegUser size={20}/>
                                        </div>
                                        <input id="clientName" className={styles.input} value={name ?? ''} maxLength={120} placeholder="Nome e sobrenome" autoComplete="name" onChange={({ target: { value } }) => setName(stripHtmlTags(value))} />
                                    </div>
                                </div>

                                <div className={styles.field}>
                                    <label className={styles.label} htmlFor="clientPhone">Telefone</label>
                                    <div className={styles.inputArea}>
                                        <div className={styles.iconArea}>
                                            <FaPhoneAlt size={18}/>
                                        </div>
                                        <InputMask id="clientPhone" className={styles.input} mask='(__) _____-____' replacement={{_: /\d/}} value={phone ?? ''} placeholder="(00) 00000-0000" inputMode="tel" autoComplete="tel" onChange={({ target: { value } }) => setPhone(value)} />
                                    </div>
                                </div>

                                {/* CONTROLE DE DOCUMENTO NA NOTA */}
                                <div className={styles.field}>
                                    <label className={styles.label} htmlFor="clientDocument">CPF na nota *</label>
                                    <div className={styles.inputArea}>
                                        <div className={styles.iconArea}>
                                            <FaRegIdCard size={20}/>
                                        </div>
                                        <InputMask id="clientDocument" className={styles.input} mask='___.___.___-__' replacement={{_: /\d/}} value={document ?? ''} placeholder="000.000.000-00" inputMode="numeric" onChange={({ target: { value } }) => setDocument(value)} />
                                    </div>

                                    <p className={styles.hint}>
                                        <FaInfoCircle size={13} color={companyData.background_color}/>
                                        Exigido pela Secretaria da Fazenda para emissão de notas fiscais.
                                    </p>
                                </div>
                            </div>

                            <div className={styles.actions}>
                                {/* CONTROLA AMOSTRA DO BOTÃO DE ENDEREÇOS DO CLIENTE */}
                                {previousUserData.length > 0 && (
                                    <button className={`${styles.btnRegister} ${styles.btnSecondary}`} onClick={() => setSelectAddressAlert(true)}>
                                        {loading ? (
                                            <ReactLoading type={'spin'} color={companyData.background_color} height={25} width={25} /> 

                                        ) : (
                                            <span className="text-button" style={{color: companyData.background_color}}>Seus dados</span>
                                        )}
                                    </button>
                                )}

                                <button className={styles.btnRegister} style={{backgroundColor: companyData.background_color}} onClick={async () => handleProceedPhase()}>
                                    {loading ? (
                                        <ReactLoading type={'spin'} color={companyData.text_color} height={25} width={25} />

                                    ) : (
                                        <>
                                            <span className="text-button" style={{color: companyData.text_color}}>Prosseguir</span>
                                            <FaArrowRight size={14} color={companyData.text_color}/>
                                        </>
                                    )}
                                </button>
                            </div>
                        </>



                    ) : phase == 2 ? (

                        <>
                            <h1 className={styles.titleForm}>Endereço de entrega</h1>

                            <span className={styles.subtitleText}>
                                Insira seus dados de entrega para que nós possamos entregar seu pedido sem nenhum problema!
                            </span>

                            <div className={styles.formInputs}>
                                <div className={styles.field}>
                                    <label className={styles.label} htmlFor="postalCode">CEP</label>
                                    <div className={styles.fieldRow}>
                                        <div className={styles.inputArea}>
                                            <div className={styles.iconArea}>
                                                <LuMapPin size={20}/>
                                            </div>

                                            <InputMask id="postalCode" className={styles.input} mask='_____-___' replacement={{_: /\d/}} value={postalCode ?? ''} placeholder="00000-000" inputMode="numeric" autoComplete="postal-code" onChange={({ target: { value } }) => setPostalCode(value)} />
                                        </div>

                                        <button className={styles.searchButton} style={{backgroundColor: companyData.background_color}} aria-label="Buscar CEP" onClick={() => handleSearchAddress()}>
                                            {searchButtonLoading ? (
                                                <ReactLoading type={'spin'} color={companyData.text_color} height={25} width={25} />
                                                
                                            ) : (
                                                <FaSearch size={20} color={companyData.text_color}/>
                                            )}
                                        </button>
                                    </div>
                                </div>

                                <div className={styles.field}>
                                    <label className={styles.label} htmlFor="district">Bairro</label>
                                    <div className={styles.inputArea}>
                                        <div className={styles.iconArea}>
                                            <BsHouses size={20}/>
                                        </div>
                                        <input id="district" className={styles.input} value={district ?? ''} maxLength={100} placeholder="Seu bairro" onChange={({ target: { value } }) => setDistrict(stripHtmlTags(value))} />
                                    </div>
                                </div>

                                <div className={styles.fieldRow}>
                                    <div className={styles.field}>
                                        <label className={styles.label} htmlFor="street">Rua</label>
                                        <div className={styles.inputArea}>
                                            <div className={styles.iconArea}>
                                                <FaStreetView size={20}/>
                                            </div>
                                            <input id="street" className={styles.input} value={street ?? ''} maxLength={200} placeholder="Nome da rua" onChange={({ target: { value } }) => setStreet(stripHtmlTags(value))} />
                                        </div>
                                    </div>

                                    <div className={`${styles.field} ${styles.numberField}`}>
                                        <label className={styles.label} htmlFor="addressNumber">Número</label>
                                        <div className={styles.inputArea}>
                                            <input id="addressNumber" className={styles.input} value={number ?? ''} maxLength={20} placeholder="Nº" onChange={({ target: { value } }) => setNumber(stripHtmlTags(value))} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className={styles.actions}>
                                <button className={styles.btnRegister} style={{backgroundColor: companyData.background_color}} onClick={async () => await handleProceedPhase()}>
                                    {loading ? (
                                        <ReactLoading type={'spin'} color={companyData.text_color} height={25} width={25} />

                                    ) : (
                                        <>
                                            <span className="text-button" style={{color: companyData.text_color}}>Prosseguir</span>
                                            <FaArrowRight size={14} color={companyData.text_color}/>
                                        </>
                                    )}
                                </button>
                            </div>
                        </>



                    ) : (
                        
                        <>
                            <h1 className={styles.titleForm}>Revisar pedido</h1>

                            <span className={styles.subtitleText}>
                                Revise seu pedido e insira a forma de pagamento para finalizar seu pedido!
                            </span>

                            <p className={styles.sectionTitle}>Seu pedido</p>

                            <div className={styles.productsContainer}>
                                {cart.current && cart.current?.products.map((item, index) => (
                                    <div key={index} className={styles.productItem}>
                                        <div className={styles.productRow}>
                                            <p className={styles.productName}>
                                                <span className={styles.qtyBadge}>{item.amount}x</span>
                                                {item.name}
                                            </p>
                                            <p className={styles.productPrice}>{formatValue(item.total_price)}</p>
                                        </div>

                                        {item.complements.length > 0 && (
                                            <div className={styles.complementsContainer}>
                                                {item.complements.map((complement, complementIndex) => (
                                                    <p key={complementIndex} className={styles.complementItem}>{complement.quantity}x {complement.complement}</p>
                                                ))}
                                            </div>
                                        )}

                                        {item.observation && (
                                            <div className={styles.observationArea}>
                                                <p className={styles.labelObservation}>
                                                    <HiOutlineDocumentText size={13} />
                                                    Observações
                                                </p>
                                                <p className={styles.observationText}>{item.observation}</p>
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>

                            <div className={styles.totalsContainer}>
                                {companyData.type == 'delivery' && companyData.delivery_tax ? (
                                    <>
                                        <div className={styles.totalRow}>
                                            <span>Subtotal</span>
                                            <span>{formatValue(cart.current?.summary?.subtotal)}</span>
                                        </div>
                                        <div className={styles.totalRow}>
                                            <span>Taxa de entrega</span>
                                            <span>{formatValue(cart.current?.summary?.delivery_tax)}</span>
                                        </div>
                                    </>
                                ) : null}

                                <div className={`${styles.totalRow} ${styles.grand}`}>
                                    <span>Total</span>
                                    <span>{cart.current && formatValue(cart.current.summary?.total)}</span>
                                </div>
                            </div>

                            <div className={styles.paymentSection}>
                                <p className={styles.sectionTitle}>Forma de pagamento</p>

                                <div className={styles.paymentGrid} role="radiogroup" aria-label="Forma de pagamento">
                                    {PAYMENT_OPTIONS.map(({ value, label, Icon }) => (
                                        <button
                                            key={value}
                                            type="button"
                                            role="radio"
                                            aria-checked={paymentMethod == value}
                                            className={`${styles.paymentOption} ${paymentMethod == value ? styles.selected : ''}`}
                                            onClick={() => setPaymentMethod(value)}
                                        >
                                            <Icon size={20} />
                                            {label}
                                        </button>
                                    ))}
                                </div>

                                {paymentMethod == '01' ? (
                                    <div className={styles.trocoContainer}>
                                        <div className={styles.trocoHeader}>
                                            <label className={styles.trocoLabel} htmlFor="checkTroco">Precisa de troco?</label>

                                            <input className={styles.checkBox} type="checkbox" name='checkTroco' id='checkTroco' checked={checkTroco} onChange={() => setCheckTroco(!checkTroco)}></input>
                                        </div>

                                        {checkTroco && (
                                            <CurrencyInput
                                                id="input-currency"
                                                name="troco"
                                                className={styles.trocoInput}
                                                placeholder="Troco para quanto? R$ 0,00"
                                                decimalsLimit={2}
                                                decimalSeparator=","
                                                groupSeparator="."
                                                prefix="R$ "
                                                value={troco}
                                                onValueChange={(value) => setTroco(value)}
                                            />
                                        )}
                                    </div>
                                ) : null}
                            </div>

                            {estimatedOrderTime && (
                                <div className={styles.estimatedTimeContainer}>
                                    <Timer size={18} color={companyData.background_color} />

                                    <p>Tempo de entrega: <strong>{estimatedOrderTime.min} - {estimatedOrderTime.max} min</strong></p>
                                </div>
                            )}

                            {/* BOTÃO DE FINALIZAÇÃO */}
                            <div className={styles.actions}>
                                <button 
                                    className={styles.btnRegister} 
                                    style={{backgroundColor: companyData.background_color}} 
                                    disabled={!paymentMethod ? true : false} 
                                    onClick={async () => await makeOrder()}
                                >
                                    {loading ? (
                                        <ReactLoading type={'spin'} color={'#fff'} height={25} width={25} /> 

                                    ) : (
                                        <>
                                            <FaCheck size={14} color={paymentMethod ? companyData.text_color : undefined}/>
                                            <span className="text-button" style={{color: paymentMethod ? companyData.text_color : undefined}}>Finalizar pedido</span>
                                        </>
                                    )}
                                </button>
                            </div>
                        </>
                    )}

                </div>
            </div>
            
            <a className={styles.buttonRedirect} href={'https://sofchef.com.br'} target='blank'>
                <img style={{width: 150}} src={require('../../assets/Logo.png')}/>
            </a>


            {/* SELECT ADDRESS ALERT */}
            <SelectUserData
                show={selectAddressAlert}
                onClose={() => setSelectAddressAlert(false)}
                companyData={companyData}
                prevDataList={previousUserData}
                onSelect={(data) => handleSelectUserData(data)}
                onRemove={(data) => handleRemoveUserData(data)}
            />

            {/* SUCESS ALERT */}
            <BoxAlert
              show={sucessAlert.show}
              title={'Sucesso'}
              text={<p>Parabéns {sucessAlert.data}, agora você faz parte do sistema de benefícios do SofChef e estará concorrendo a promoções e brindes em suas próximas visitas ao {companyData.name}!</p>}
              onClose={() => navigate('cart')}
            />

            {/* WARN ALERT */}
            <BoxAlert
              show={warnAlert.show}
              title={warnAlert.title}
              text={<p>{warnAlert.text}</p>}
              onClose={() => setWarnAlert({show: false, title: null, text: null})}
            />
        </div>
    );
}

export default RegisterDeliveryData;
